import { FunctionComponent, useContext } from "react";
import { Option } from "space-monad";
import styled from "styled-components";
import { PrimaryButton } from "../../../../../components/button";
import { Icon } from "../../../../../components/icons";
import {
  CenteredFlex,
  columnFlex,
  Flex,
} from "../../../../../components/layout";
import { StepperContext } from "../../../../../components/stepper/context";
import { colours } from "../../../../../styles/colours";
import { size } from "../../../../../styles/media";
import { FormWidget } from "../common/components";

const StyledWidget = styled(FormWidget)`
  flex-grow: 1;
  display: flex;
`;

const MainIcon = styled(Icon)`
  height: 8em;
  width: 8em;
  margin: 2em 0;
`;

interface IResultPageProps {
  error: Option<Error>;
}

const Wrapper = styled(Flex)`
  ${columnFlex};
  ${CenteredFlex};
  max-width: 100%;
  flex-grow: 1;
`;

const Title = styled.h1`
  @media (max-width: ${size.tablet - 1}px) {
    margin-top: 0;
  }
`;

const ResultPage: FunctionComponent<IResultPageProps> = ({ error }) => {
  const { back } = useContext(StepperContext);

  return (
    <StyledWidget>
      <Wrapper>
        {error.fold(
          () => (
            <>
              <Title>Success!</Title>
              <MainIcon type="veryGoodCheck" />
              <p>
                We have successfully received your application and it will be
                reviewed accordingly. A participation acknowledgement has been
                sent via email.
              </p>
            </>
          ),
          (err) => (
            <>
              <Title>Error</Title>
              <MainIcon type="close" colour1={colours.redFailed} />
              <p>{err.message}</p>
              <p>
                <PrimaryButton onClick={() => back.next()}>Back</PrimaryButton>
              </p>
            </>
          )
        )}
      </Wrapper>
    </StyledWidget>
  );
};

export default ResultPage;
